<template>
	<div class="layout-grid">
		<div class="ui five doubling stackable cards">
			<layout-card v-for="layout in visibleLayouts" :key="layout.layoutId" :layout="layout" :create-layout-actions="createLayoutActions" @deleteLayout="deleteLayout" @updateSpecialId="updateSpecialId" :layout-type-display="layoutTypeDisplay" :job-id="jobId" :season-id="seasonId" />
			<div class="ui inverted active dimmer" v-if="loading"><div class="ui text loader">Loading</div></div>
		</div>
		<div class="layout-grid-pager" v-if="totalPages > 1">
			<div class="ui icon button" :class="{ disabled: page <= 1 }" @click="previousPage"><i class="left angle icon"/></div>
			<span>{{ pagingDisplay }}</span>
			<div class="ui icon button" :class="{ disabled: page >= totalPages }" @click="nextPage"><i class="right angle icon"/></div>
		</div>
		<div class="ui warning message" v-if="!visibleLayouts.length && !loading">{{ noLayoutsWarning }}</div>
	</div>
</template>

<script>
import LayoutCard from './LayoutCard.vue';

export default {
	props: {
		layoutCategory: null,
		createLayoutActions: null,
		filter: null,
		layoutType: null,
		layoutTypeDisplay: null,
		layoutsPerPage: {
			default: 15
		},
		orgId: null,
		jobId: null,
		seasonId: null
	},
	data: function() {
		return {
			loading: true,
			layouts: [],
			page: 1
		};
	},
	computed: {
		noLayoutsWarning: function() {
			if(this.filter.length) {
				return 'No ' + this.layoutTypeDisplay.toLowerCase() + 's match that search criteria';
			} else {
				return 'No ' + this.layoutTypeDisplay.toLowerCase() + 's.  Why not add some?';
			}
		},
		visibleLayouts: function() {
			var layouts = this.filteredLayouts;

			var start = (this.page - 1) * this.layoutsPerPage;
			return layouts.slice(start, start + this.layoutsPerPage);
		},
		filteredLayouts: function() {
			var filter = this.filter.toLowerCase();
			return this.layouts.filter(function(layout) {
				return layout.layoutName.toLowerCase().indexOf(filter) !== -1;
			});
		},
		pagingDisplay: function() {
			return 'Page ' + this.page + ' of ' + this.totalPages;
		},
		totalPages: function() {
			return Math.ceil(this.filteredLayouts.length / this.layoutsPerPage);
		}
	},
	watch: {
		layoutCategory: function(value) {
			if(value) {
				this.page = 1;
				this.loadLayoutCategory(this.layoutCategory);
			}
		},
		filter: function() {
			this.page = 1;
		}
	},
	methods: {
		loadLayoutCategory: function(layoutCategory) {
			var me = this;
			this.layouts = [];
			this.loading = true;

			var url = 'ajax/getLayouts.php?category=' + layoutCategory.id +'&type=' + this.layoutType;
			if(layoutCategory.id === 'global') {
				url = 'ajax/getLayouts.php?type=' + this.layoutType;
			} else if(typeof this.orgId === 'undefined') {
				url += '&studioLayouts=true';
			} else {
				url += '&customerLayout=true';
			}

			$.ajax({
				url: url,
				dataType: 'json',
				success: function(data) {
					data.results.caseInsensitiveSort('title');
					me.layouts = data.results;
					me.loading = false;
				},
				error: function() {
					$.Alert('Error', 'Failed to load layouts');
				}
			});
		},
		deleteLayout: function(layout) {
			this.layouts.removeItem(layout);
		},
		updateSpecialId: function(layout, specialId) {
			this.layouts.forEach(function(layout) {
				if(layout.specialId === specialId) {
					layout.specialId = null;
				}
			});

			Vue.set(layout, 'specialId', specialId);
		},
		previousPage: function() {
			this.page = Math.max(1, this.page - 1);
		},
		nextPage: function() {
			this.page = Math.min(this.totalPages, this.page + 1);
		}
	},
	components: {
		LayoutCard
	}
};
</script>

<style scoped>
.layout-grid > .warning.message {
	margin-top: 2em;
}

.layout-grid-pager {
	margin-top: 1em;
	display: flex;
	justify-items: center;
	justify-content: center;
	align-items: center;
}

.layout-grid-pager > .icon.button:first-child {
	margin-right: 0.6em;
}
.layout-grid-pager > .icon.button:last-child {
	margin-left: 0.6em;
}
</style>